import styled from 'styled-components';
import cores from '../../styles/cores';

export const ModalContainerEditCommission = styled.div`
  margin: 0 auto;
  width: 100%;
  padding: 16px;

  .alert-warning {
    margin-top: 16px;
    font-size: 14px;
    display: flex;
    align-items: center;
  }
  
  .field-group {
    max-width: 100%;
    padding: 0px;
    flex-wrap: nowrap;
    display: flex;
    margin-top: 24px;
    gap: 16px;
    
    .date-input {
      min-width: 200px;
      flex-shrink: 0;
    }
  }

  .radio-group-container {
    margin-top: 24px;
    
    legend {
      margin-bottom: 8px;
    }
    
    .MuiRadio-root {
      color: ${cores.lavender};
    }
  }
`;

export const BotaoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 24px;

  .btn {
    width: 48%;
  }
`;